
import { IComponent } from "./IComponent";
import { ComponentTypes } from "./ComponentTypes";


export class Component implements IComponent
{
    id: number = 0;
    companyId: number = 0;
    componentTypeId: number = 0;
    componentTypeCode: string = "";
    componentTypeName: string = "";
    parentId: number = 0;
    parentName: string = "";
    parentDisplayOrder: number = 0;
    parentTreeOrder: string = "";
    healthIndicatorId: number = 0;
    healthIndicatorCode: string = "";
    healthIndicatorName: string = "";
    healthIndicatorScore: number = 0;
    healthIndicatorStatusId: number = 0;
    healthIndicatorStatusCode: string = "";
    healthIndicatorStatusName: string = "";
    healthIndicatorDataSourceNames: string = "";
    healthIndicatorDataSourceValues: string = "";
    healthIndicatorDataSourceUOMs: string = "";
    healthIndicatorLastProcessDate: Date = new Date();
    healthIndicatorLastProcessTimeZone: string = "";
    offlineIndicatorId: number = 0;
    offlineIndicatorCode: string = "";
    offlineIndicatorName: string = "";
    offlineIndicatorScore: number = 0;
    offlineIndicatorStatusId: number = 0;
    offlineIndicatorStatusCode: string = "";
    offlineIndicatorStatusName: string = "";
    offlineIndicatorDataSourceNames: string = "";
    offlineIndicatorDataSourceValues: string = "";
    offlineIndicatorDataSourceUOMs: string = "";
    offlineIndicatorLastProcessDate: Date = new Date();
    offlineIndicatorLastProcessTimeZone: string = "";
    code: string = "";
    name: string = "";
    description: string = "";
    displayOrder: number = 0;
    treeOrder: string = "";
    level: number = 0;
    branchId: number = 0;
    location: string = "";
    latitude: number = 0;
    longitude: number = 0;
    visible: boolean  = false;
    uiConfiguration: string = "";
    active: boolean  = false;
    componentType: ComponentTypes = 1;
    indicatorLastProcessDateTimeOffset: Date = new Date();
}
